import React from 'react';
import { WavesIcon } from 'lucide-react';
import { siteConfig } from '../data/siteConfig';
export function SiteHeader() {
  return <header className="border-b border-line bg-white" data-id="element-161" data-mp="19v00mtul6tfl">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4" data-id="element-162" data-mp="1nnfxte0t3x8l">
        <a href="#top" className="flex items-center gap-2 font-display text-lg font-extrabold text-navy" data-id="element-163" data-mp="1io3bcuduks6j">
          <WavesIcon className="h-6 w-6 text-aqua" aria-hidden="true" data-id="element-164" data-mp="uxzb8wzvbaka" />
          {siteConfig.productName}
        </a>
        <a href="#offer" className="hidden rounded-lg px-3 py-2 text-sm font-semibold text-navy transition-colors duration-150 ease-out hover:bg-mist sm:inline-block" data-id="element-165" data-mp="qxfdpsbdu4xm">
          See the pack — {siteConfig.price}
        </a>
      </div>
    </header>;
}